import { useSnackbar } from "notistack";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi";
import EmailModal from "../../modals/EmailModal";
import Modal1 from "../../modals/Modal1";
import TagFilter from "../../tag/TagFilter";
import Tag from "../../tag/Tag";

export const FolderModalsWrapper = ({
  email_open,
  setEmailOpen,
  setEmailForXml,
  setEmailForExpert,
  setEmailModifThermal,
  setEmailForDocRequest,
  email_for_expert,
  email_for_xml,
  email_modif_thermal,
  email_for_doc_request,
  selected_doc_names,
  selected_doc_ids,
  navigateWorkspace,
  tag_index,
  setTagIndex,
  tag_open,
  setTagOpen,
  folderData,
  orgData,
  masterData,
  id,
  handleFetchData,
  prefix,
  workspaceData,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleSetTag = async (tag_nom, folder_id) => {
    const folder = folderData;

    const folder_tags = (folder.tags || []).concat(folder.tags2 || []) || [];

    const my_tags = folder_tags.filter((tag) => tag.org_id === orgData.id);
    const my_tag = my_tags[tag_index];
    const folder_tags_removed = folder_tags.filter(
      (tag) =>
        tag != undefined &&
        (tag?.nom !== my_tag?.nom || tag?.org_id !== my_tag?.org_id)
    );
    let new_tag = my_tag;
    if (tag_nom == "pas de tag") {
      new_tag = null;
    } else if (tag_nom == "#nouveau") {
      new_tag = {
        nom: "#nouveau",
        org_id: orgData.id,
        colorint: -2494209,
      };
    } else {
      const org_tag = orgData.tags.find((tag) => tag.nom === tag_nom);
      new_tag = {
        nom: org_tag.nom,
        org_id: orgData.id,
        colorint: org_tag?.colorint,
      };
    }
    // remove my_tag from folder_tags

    let new_folder_tags = [];
    if (new_tag) {
      new_folder_tags = [...folder_tags_removed, new_tag];
    } else {
      new_folder_tags = folder_tags_removed;
    }

    await updateDocDataFieldApi(folder.ref, "tags", new_folder_tags, prefix);
    await updateDocDataFieldApi(folder.ref, "tags2", [], prefix);
    handleClickVariant("Tag ajouté", "success");
    setTagOpen(false);
    handleFetchData();
  };

  return (
    <div
      className={`
    
    ${email_open || tag_open ? "" : ""}
    "flex flex-col"`}
    >
      <Modal1 isOpen={email_open} onClose={() => setEmailOpen(false)}>
        <EmailModal
          folderData={folderData}
          orgData={orgData}
          masterData={masterData}
          onClose={(fetch = true) => {
            setEmailOpen(false);
            setEmailForXml(false);
            setEmailForExpert(false);
            setEmailModifThermal(false);
            setEmailForDocRequest(false);
            fetch && handleFetchData();
          }}
          for_expert={email_for_expert}
          for_xml={email_for_xml}
          for_modif_thermal={email_modif_thermal}
          for_doc_request={email_for_doc_request}
          selected_doc_names={selected_doc_names}
          selected_doc_ids={selected_doc_ids}
          navigateWorkspace={navigateWorkspace}
          workspaceData={workspaceData}
        ></EmailModal>
      </Modal1>

      <Modal1
        isOpen={tag_open}
        onClose={() => {
          setTagOpen(false);
        }}
      >
        <Tag
          tag_folder_id={id}
          orgData={orgData}
          handleSetTag={handleSetTag}
          navigateWorkspace={navigateWorkspace}
        ></Tag>
      </Modal1>
    </div>
  );
};
